import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/sept-oct2021/sponsors/pbsutah.jpg',
      link: 'https://www.pbsutah.org',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/arnold-machinery.jpg',
      link: 'https://www.arnoldmachinery.com',
      alt: 'Arnold Machinery',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/grand-america.jpg',
      link: 'https://www.grandamerica.com',
      alt: 'The Grand America Hotel',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/Classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/Eccles-Symphony-ad.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/opera-season.jpg',
      link: 'https://www.utahopera.org/',
      alt: 'Utah Opera 2021-22 Season',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/symphony-season.jpg',
      link: 'https://www.utahsymphony.org/',
      alt: 'Utah Symphony 2021-22 Season',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/Ghostlight_Sep.jpg',
      link: 'https://soundcloud.com/utahsymphony',
      alt: 'Ghostlight Podcast',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/volunteer.jpg',
      link: 'https://www.utahsymphony.org/',
      alt: 'Utah Symphony Volunteer Benefits',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/ufs.jpg',
      link: 'https://utahfoodservices.com/',
      alt: 'Utah Symphony Volunteer Benefits',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/US-in-schools.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Education with the Utah Symphony',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/US-SocialMedia.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Utah Symphony Social Media information',
      class: 'webFormat',
    },
    {
      image: '/sept-oct2021/sponsors/education.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Utah Symphony Education information',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
